export type AnnotationStyle = "DEFAULT" | "SUCCESS" | "ERROR" | "INFO" | "WARNING";

export type AnnotationScope = "build" | "job";

export enum AnnotationsTab {
  Build = "build",
  Jobs = "jobs",
}

export type Annotation = {
  id: string;
  context: string;
  style: AnnotationStyle;
  scope: AnnotationScope;
  jobUuid: string | null;
  body: { html: string | null | undefined };
};
